import ClassicBridge from '../next/ClassicBridge'

class AccrualRuleFromDateSelector {
    constructor(placeholder, dateFormat, onChangeCallback) {
        this.placeholder = placeholder

        this.selector = ClassicBridge.integrateFromDateSelector(this.placeholder, {
            dateFormat: dateFormat,
            onSelect: (date) => {
                this.date = date
                this.selector.setProps({ date: this.date })
                onChangeCallback()
            }
        })
    }

    show() {
        $(this.placeholder).show()
    }

    hide() {
        $(this.placeholder).hide()
    }

    getValue() {
        return this.date
    }

    enable() {
        this.selector.setProps({ isDisabled: false })
    }

    disable() {
        this.selector.setProps({ isDisabled: true })
    }

    setDates(date, today) {
        this.date = date
        this.selector.setProps({ date: this.date, today })
    }

    setPlaceholderDateValue(today) {
        this.date = ClassicBridge.getNextFridayDate(today)
        this.selector.setProps({ date: this.date, today })
    }
}

export default AccrualRuleFromDateSelector



// WEBPACK FOOTER //
// ./web/js/controls/AccrualRuleFromDateSelector.js